import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { PortalService } from '../../../core/services/portal.service';
import { Subject } from 'rxjs';

interface RespInterface {
  status: boolean;
  total: number;
  bots: any[];
}

interface PostStatus {
  status: boolean;
  error?: string;
}

export interface ReconnectStatus {
  status: boolean;
  message: string;
}

@Injectable()
export class BotsService {
  private readonly apiUrl: string = PortalService.ApiUrl;
  private reconnect$: Subject<ReconnectStatus> = new Subject<ReconnectStatus>();

  constructor(private http: HttpClient) {}

  getReconnectStream() {
    return this.reconnect$;
  }

  setReconnectStream(status: ReconnectStatus) {
    this.reconnect$.next(status);
  }

  getReconnect(botID: string) {
    return this.http.get<{ status: boolean; provider_data: any }>(
      this.apiUrl + `/connection/${botID}/instagram`
    );
  }

  toReconnect(botID: string, data: any) {
    return this.http.put(this.apiUrl + `/connection/instagram/${botID}`, data);
  }

  getVipBots(limit: number = 20, offset: number = 0, warnings: boolean) {
    return this.http.get<RespInterface>(this.apiUrl + '/bots', {
      params: new HttpParams()
        .set('limit', limit.toString())
        .set('offset', offset.toString())
        .set('tag', 'vip')
        .set('active', 'true')
        .set('has_warnings', String(warnings)),
    });
  }

  getActiveBots(limit: number = 20, offset: number = 0, warnings: boolean) {
    return this.http.get<RespInterface>(this.apiUrl + '/bots', {
      params: new HttpParams()
        .set('limit', limit.toString())
        .set('offset', offset.toString())
        .set('tag', '!vip')
        .set('active', 'true')
        .set('has_warnings', String(warnings)),
    });
  }

  getDisabledBots(limit: number = 20, offset: number = 0) {
    return this.http.get<RespInterface>(this.apiUrl + '/bots', {
      params: new HttpParams()
        .set('limit', limit.toString())
        .set('offset', offset.toString())
        .set('active', 'false'),
    });
  }

  searchVipBot(name: string, warnings: boolean, limit: number) {
    return this.http.get<RespInterface>(this.apiUrl + '/bots', {
      params: new HttpParams()
        .set('name', name)
        .set('limit', limit.toString())
        .set('tag', 'vip')
        .set('active', 'true')
        .set('has_warnings', String(warnings)),
    });
  }

  searchActiveBot(name: string, warnings: boolean, limit: number) {
    return this.http.get<RespInterface>(this.apiUrl + '/bots', {
      params: new HttpParams()
        .set('name', name)
        .set('limit', limit.toString())
        .set('tag', '!vip')
        .set('active', 'true')
        .set('has_warnings', String(warnings)),
    });
  }

  searchDisabledBot(name: string, limit: number) {
    return this.http.get<RespInterface>(this.apiUrl + '/bots', {
      params: new HttpParams()
        .set('name', name)
        .set('limit', limit.toString())
        .set('active', 'false'),
    });
  }

  changeStateBot(botId: string, path: string, body: object) {
    return this.http.post<PostStatus>(this.apiUrl + path + botId, body);
  }

  changeStatusBot(botId: string, status: any) {
    return this.http.patch<any>(this.apiUrl + '/bot/' + botId, {
      tag: status,
      settings: {
        monitoring: {
          warnings: {
            active: status === 'vip',
          },
        },
      },
    });
  }

  cloneBot(body: object) {
    return this.http.post<any>(this.apiUrl + '/bot/', body);
  }
  createBot(name: string): any {
    const body = {
      name,
    };
    console.log(body);

    return this.http.post<any>(this.apiUrl + '/bot', body);
  }
}
